import React from 'react';

const Work = () => {
  return (
    <section id="work" className="py-4 pb-8 bg-background text-bone-white md:pl-6 pl-2">
      <div className="px-3 lg:px-6 xl:px-8 2xl:px-10 text-left">
        <h2 className="text-4xl font-bold mb-6">Work Experience</h2>
          
        <div className="mb-6">
          <h3 className="text-xl font-semibold">PwC - Digital Assurance & Transparency Associate</h3>
          <div className="text-sm text-gray-400 mb-2">July 2026 - Present</div>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold">PwC - Digital Assurance & Transparency Intern</h3>
          <div className="text-sm text-gray-400 mb-2">June 2025 - August 2025</div>
          <div className="code-tag" data-before="<div>" style={{ fontSize: '14px', color: 'blue' }}></div>
          <div className="text-description max-w-2xl xl:max-w-3xl 2xl:max-w-4xl mb-2">
          Developed IT production engineering controls to improve compliance and streamline operations.
          </div>
          <div className="code-tag" data-after="</div>" style={{ fontSize: '14px', color: 'blue' }}></div>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold">Kaiser Permanente - Software and IT Intern</h3>
          <div className="text-sm text-gray-400 mb-2">June 2024 - September 2024</div>
          <div className="code-tag" data-before="<div>" style={{ fontSize: '14px', color: 'blue' }}></div>
          <div className="text-description max-w-2xl xl:max-w-3xl 2xl:max-w-4xl mb-2">
           Enhanced the user interface of internal tools and software while managing server data transfer operations.
          </div>
          <div className="code-tag" data-after="</div>" style={{ fontSize: '14px', color: 'blue' }}></div>
        </div>
        
      </div>
    </section>
  );
};

export default Work;
